import { render, staticRenderFns } from "./ConAdminPanels.vue?vue&type=template&id=6f3210d2"
import script from "./ConAdminPanels.vue?vue&type=script&lang=js"
export * from "./ConAdminPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports